module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "100%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "rules": _vm.editFormRules,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公告标题：",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "15",
      "show-word-limit": "",
      "placeholder": "请输入公告标题"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公告内容：",
      "prop": "content"
    }
  }, [_c('div', {
    ref: "editorElem",
    staticStyle: {
      "text-align": "left"
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clear.apply(null, arguments)
      }
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-932927f6!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/nav3/noticeManager.vue
// module id = 763
// module chunks = 2